angular.module('callX').controller('LeadHistoryCtrl', ['$scope', '$modalInstance', '$state','object', function($scope, $modalInstance, $state,object) {

    $scope.obj = object;
//    console.log($scope.obj,"this is object transferred")

    $scope.ok = function () {
        $modalInstance.close('ok');
    };

    // $scope.cancel = function () {
    //     $modalInstance.dismiss('cancel');
    // };
}]);